function Categories(){
    return(
        <div class="categories">
        <p>Development</p>
        <p>Bussines</p>
        <p>IT & Software</p>
        <p>Personal Development</p>
        <p>Design</p>
        <p>Marketing</p>
    </div>
    )
}

export default Categories